import React from 'react'

/** What a share chart prints. Widths stay the stamped shares either way. */
export type ShareUnit = 'percent' | 'count'

/** The host's words, in the viewer's language: the group's name and each button's. */
export interface ShareUnitToggleLabels {
  group: string
  percent: string
  count: string
}

export interface ShareUnitToggleProps {
  value: ShareUnit
  onChange: (unit: ShareUnit) => void
  labels: ShareUnitToggleLabels
  testIdPrefix?: string
}

const UNITS: Array<{ unit: ShareUnit; glyph: string }> = [
  { unit: 'percent', glyph: '%' },
  { unit: 'count', glyph: '#' },
]

/** The survey card's # / % switch. One control for every panel on the card. */
export function ShareUnitToggle(props: ShareUnitToggleProps) {
  const { value, onChange, labels, testIdPrefix = 'share-unit-' } = props

  return (
    <div role="group" aria-label={labels.group} data-testid={`${testIdPrefix}group`} style={{ display: 'inline-flex', gap: 4 }}>
      {UNITS.map((entry) => {
        const selected = entry.unit === value
        return (
          <button
            key={entry.unit}
            type="button"
            aria-pressed={selected}
            aria-label={labels[entry.unit]}
            data-testid={`${testIdPrefix}${entry.unit}`}
            onClick={() => onChange(entry.unit)}
            style={{
              border: selected ? '1px solid var(--slide-chart-1)' : '1px solid var(--slide-border-soft)',
              background: selected ? 'var(--slide-accent-soft)' : 'var(--slide-bg)',
              borderRadius: 999,
              padding: '4px 10px',
              boxSizing: 'border-box',
              lineHeight: 1.2,
              fontSize: 12,
              color: 'var(--slide-text-primary)',
              cursor: 'pointer',
            }}
          >
            {entry.glyph}
          </button>
        )
      })}
    </div>
  )
}
